import React, { useEffect, useState } from "react";
import ContestDescription from "./ContestDetails/ContestDescription";
import CommonContestEntries from "./ContestDetails/CommonContestEntries";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPostsById } from "../../../../redux/posts/action";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import getTimeDifference from "../../../Common/TimeDifference";
import {
  formatNumberWithCommas,
  getMemberSince,
  getPosttype,
} from "../../../Common/AllDateTimeReleventFormate";
import HomeCommonNavigation from "../../../Common/HomeCommonNavigation";

export default function ContestDetails() {
  const path = "Assets/scss/searchcontestparticipate.module.scss";
  const path1 = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
    LoadCSSforfirstTime(path1);
  }, [path]);
  const [activeTab, setActiveTab] = useState("description");


  const { id } = useParams();
  const posts = useSelector(({ posts: { postbyid } }) => postbyid);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPostsById(id));
  }, [id]);

  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();


  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };


  return (
    <div className=" project-section project-details col-lg-10 mx-auto">
      <p className="breadcrumbs">
        <HomeCommonNavigation type={posts?.type} />WBO details
      </p>
      <div className="tab-sec">
        <ul className="nav nav-tabs">
          <li className="nav-posts">
            <a
              onClick={() => handleTabClick("description")}
              className={`nav-link ${activeTab === "description" ? "active" : ""}`}
            >
              Contest description
            </a>
          </li>
          <li className="nav-posts">
            <a
              onClick={() => handleTabClick("entries")}
              className={`nav-link ${activeTab === "entries" ? "active" : ""}`}
            >
              Entries
            </a>
          </li>
        </ul>

        <div className="tab-content">
          {activeTab == "description" && (
            <div className="tab-pane active" id="description">
              <ContestDescription posts={posts} />
            </div>
          )}
          {activeTab == "entries" && (
            <div>
              <h1>Contest description</h1>
              <div className="entries">
                <div className="post-details post-back ">
                  <div className="post-flex">
                    <div>
                      <h5>
                        {posts.title} <span className="contest">{getPosttype(posts.type)}</span>
                      </h5>
                      <div className="dollar-sec">
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/project/dollar.svg`}
                            alt=""
                          />
                          {posts?.type == 2 ? "Prize" : "Budget"}: $
                          {formatNumberWithCommas(posts.price)}
                        </p>
                        {posts?.type == 3 ? (
                          <p>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/job-type.svg`}
                              alt=""
                            />
                            Job type:
                            {posts?.work_location == 1
                              ? "Virtual"
                              : posts?.work_location == 2
                                ? "Physical"
                                : ""}
                          </p>
                        ) : (
                          <p>
                            <img
                              src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                              alt=""
                            />
                            Deadline:&nbsp;
                            {posts?.type == 2 ? (
                              <> {getMemberSince(posts?.last_date)} </>
                            ) : (
                              <>
                                {posts?.duration}&nbsp;
                                {posts?.duration_type == 1
                                  ? "Days"
                                  : posts?.duration_type == 2
                                    ? "Weeks"
                                    : posts?.duration_type == 3
                                      ? "Months"
                                      : ""}
                              </>
                            )}
                          </p>
                        )}

                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/project/message.svg`}
                            alt=""
                          />
                          Posted:{getTimeDifference(posts.created_on)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <CommonContestEntries posts={posts} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
